export default "__VITE_ASSET__D56Opt7O__"